import React, { useState } from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import { Box, TextField, MenuItem, Collapse, Typography } from '@material-ui/core'
import { ProductCardModel } from '../../../../../server/mpsklad_core/Models/MpCard/ProductCardModel'
import { CategoryAttributeModel } from '../../../../../server/mpsklad_core/Models/MpCard/CategoryAttributeModel'
import { Button } from "../../../../shared/ui/button"

type WbVariantsProps = {
  editableAttributes: CategoryAttributeModel[]
  existingVariants: ProductCardModel[]
}

export const WbVariants: React.FC<WbVariantsProps> = ({ editableAttributes, existingVariants }) => {
  const { control, getValues } = useFormContext()
  const [expandedIndexes, setExpandedIndexes] = useState<number[]>([])

  const toggleExpanded = (index: number) => {
    setExpandedIndexes(prev =>
      prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    )
  }

  const handleSaveVariant = (index: number) => {
    const values = getValues(`variants.${index}`)
    console.log('Сохраняем вариант', values)
  }

  return (
    <Box mt={2}>
      {existingVariants.map((variant, index) => {
        const isExpanded = expandedIndexes.includes(index)

        // Собираем все атрибуты без дублирования
        const allAttributes: CategoryAttributeModel[] = [
          ...variant.attributes.filter(
            va => !editableAttributes.some(ea => ea.id === va.id)
          ),
          ...editableAttributes.filter(
            ea => !variant.attributes.some(va => va.id === ea.id)
          )
        ]

        return (
          <Box key={variant.id} mb={2} p={2} border="1px solid #ccc">
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="subtitle1">
                {variant.attributes.find(a => a.apiAttributeId === 'vendor_code')?.currentValue || 'Без артикула'} —{' '}
                {variant.attributes.find(a => a.apiAttributeId === 'name')?.currentValue || 'Без названия'}
              </Typography>
              <Button type="button" onClick={() => toggleExpanded(index)}>
                {isExpanded ? 'Свернуть' : 'Развернуть'}
              </Button>
            </Box>

            <Collapse in={isExpanded}>
              <Box mt={2}>
                {allAttributes.map((attr, attrIndex) => {
                  const defaultValue = attr.currentValue || ''
                  if (attr.enumValues && attr.enumValues.length > 0) {
                    return (
                      <Controller
                        key={attr.id}
                        control={control}
                        name={`variants.${index}.attributes.${attrIndex}.currentValue`}
                        defaultValue={defaultValue}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            select
                            label={attr.name}
                            variant="outlined"
                            size="small"
                            fullWidth
                            margin="dense"
                          >
                            {(attr.enumValues || []).map((v) => (
                              <MenuItem key={v} value={v}>
                                {v}
                              </MenuItem>
                            ))}
                            
                          </TextField>
                        )}
                      />
                    )
                  } else {
                    return (
                      <Controller
                        key={attr.id}
                        control={control}
                        name={`variants.${index}.attributes.${attrIndex}.currentValue`}
                        defaultValue={defaultValue}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            label={attr.name}
                            variant="outlined"
                            size="small"
                            fullWidth
                            margin="dense"
                          />
                        )}
                      />
                    )
                  }
                })}

                <Button
                  type="button"
                  color="primary"
                  onClick={() => handleSaveVariant(index)}
                  style={{ marginTop: 8 }}
                >
                  Сохранить вариант
                </Button>
              </Box>
            </Collapse>
          </Box>
        )
      })}
    </Box>
  )
}
